import React, { useEffect, useRef, useState } from "react";
import styles from "./Signup.module.css";
import { useNavigate, Navigate, Link } from "react-router-dom";
import LineChart from "../../assets/line-chart.gif";
import BotIcon from "../../assets/botIco.svg";
import jwt_decode from "jwt-decode";

import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Stack, Typography } from "@mui/material";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { toast, ToastContainer } from 'react-toastify';

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import StepLabel from "@mui/material/StepLabel";
import "react-toastify/dist/ReactToastify.css";
import { DatePicker } from 'antd';


const steps = ["Personal Information", "Organizational Information"];

// import Typography from '@mui/material/Typography';
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import { BackendURL } from "../../../env";

async function loginUser(credentials: any) {
  const userinfo = credentials.username;
  //@ts-ignore
  const domain = userinfo.split("\\")[0];
  //@ts-ignore
  const uname = userinfo.split("\\")[1];

  const items = {
    username: uname,
    password: credentials.password,
    domain: domain,
  };


  return fetch("https://genie-uat.motherson.com/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(items),
  }).then((data) => data.json());
}


function base64Decode(str: string) {
  try {
    return JSON.parse(
      decodeURIComponent(
        atob(str)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      )
    );
  } catch (e) {
    console.error("Base64 decode error:", e);
    return null;
  }
}

function parseJwt(token: string) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      return null;
    }
    return base64Decode(base64Url);
  } catch (e) {
    console.error("JWT parse error:", e);
    return null;
  }
}

export default function Signup() {
  // otp timer start
  const [progress, setProgress] = React.useState(180);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress <= 180 ? prevProgress - 1 : 0
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  // otp timer end



  const domain = [
    { value: "SMG", label: "SMG" },
    { value: "SMR", label: "SMR" },
    { value: "SMP", label: "SMP" },
    { value: "other", label: "Other" },
  ];
  const companyType = [
    { value: "Motherson", label: "Motherson" },
    { value: "External", label: "External" },
  ];



  type DomainOption = {
  value: string;
  label: string;
};
  const animatedComponents = makeAnimated();

   

  const [usernameInput, setUserName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState<string | null>(null);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [otpMessage, setOtpMessage] = useState<string | null>(null);
  const [otpDigits, setOtpDigits] = useState<string[]>(Array(6).fill(""));
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [isEmailEditable, setIsEmailEditable] = useState(true);
  const [isEmailChanged, setIsEmailChanged] = useState(false);
  
  
  const [errorMessage, setErrorMessage] = useState("");

const [selectedCompany, setSelectedCompany] = useState("");
 const [selectedDomain, setSelectedDomain] = useState<DomainOption | null>(null);
const [companyName, setCompanyName] = useState('');
 



  const RESEND_SECONDS = 45;
  const [resendIn, setResendIn] = useState(0);

  useEffect(() => {
    if (resendIn <= 0) {
      setProgress(0);
      return;
    }

    const interval = setInterval(() => {
      setResendIn((prev) => {
        const newTime = prev - 1;
        setProgress((newTime / RESEND_SECONDS) * 100);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendIn]);


  const startResendTimer = () => {
    setResendIn(RESEND_SECONDS);
    setProgress(100);
  };

  const handleVerifyClick = () => {
  if (
    !firstName.trim() ||
    !lastName.trim() ||
    !selectedDate || 
    !mobile.trim() ||
    mobile.length !== 10
  ) {
    setErrorMessage("Please fill all fields correctly before verifying.");
  } else {
    setErrorMessage("");
 
  }
};

  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.(com|net|org)$/;

  const handleOtpChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otpDigits];
    updatedOtp[index] = value;
    setOtpDigits(updatedOtp);

    setOtpError(null);

     if (value) {
    
    if (index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  } else {
   
    if (index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      prevInput?.focus();
    }
  }
    // if (value && index < 5) {
    //   const nextInput = document.getElementById(`otp-input-${index + 1}`);
    //   nextInput?.focus();
    // }

    const completedOtp = updatedOtp.join("");


    if (completedOtp.length < 6) {
      setOtpError(null);
    }

    if (updatedOtp.every((digit) => digit !== "")) {
      const completeOtp: any = updatedOtp.join("");
      handleVerifyOtp(completeOtp);
    }
  };

  function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >{`${Math.ceil((props.value / 100) * RESEND_SECONDS)}s`}</Typography>
        </Box>
      </Box>
    );
  }

  const getFullOtp = () => otpDigits.join("");
  const isOtpComplete = () => otpDigits.every((digit) => digit !== "");


  const handleSendOtp = async (e?: React.MouseEvent<HTMLAnchorElement>) => {
    if (e) e.preventDefault();

    if (otpLoading || otpVerifyLoading || resendIn > 0 || otpVerified) return;

    setOtpMessage(null);
    setEmailError(null);

    if (!email) {
      setEmailError("Email is required.");
      return;
    }
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format.");
      return;
    }

    setOtpLoading(true);
    try {
      const res = await fetch("/send_otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      let data: any = null;
      try {
        data = await res.json();
      } catch { }

      if (res.status === 200 && data?.status === "OTPInsertedSuccess") {
        setOtpSent(true);
        setOtpVerified(false);
        setOtp("");
        setOtpDigits(Array(6).fill(""));
        setOtpMessage("OTP sent to your email.");
        startResendTimer(); // <- RESETS TIMER
      } else if (res.status === 401 && data?.status === "UserAlreadyExists") {
        
        setOtpVerified(false);
        setOtpError(data.message || "Email Already Exist.");
        //  setOtpMessage(data?.message || "OTP has expired.");
        setOtpDigits(Array(6).fill(""));
        setOtpSent(false);
        setResendIn(0);
      }
      
    } catch (err) {
      console.error(err);
      setOtpMessage("Network error. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };


  const handleVerifyOtp = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e?.preventDefault?.();
    if (!otpSent || otpVerifyLoading || otpVerified) return;

    const fullOtp = getFullOtp();

    if (fullOtp.length < 6) {
      setOtpMessage("Please enter the full OTP.");
      return;
    }

    setOtpVerifyLoading(true);
    setOtpMessage(null);

    try {
      const res = await fetch("/verify_otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp: fullOtp }),
      });

      const data = await res.json();

      if (res.status === 200 && data?.status === "Valid") {
        setOtpVerified(true);
        setOtpMessage(data?.message || "OTP verified successfully.");

      } else if (res.status === 401 && data?.status === "UserAlreadyExists") {
        setOtpVerified(false);
        setOtpError(data.message || "Email Already Exist.");
        //  setOtpMessage(data?.message || "OTP has expired.");
        setOtpDigits(Array(6).fill(""));
        setOtpSent(false);
        setResendIn(0);
      }
       else if (res.status === 401 && data?.status === "Expired") {
        setOtpVerified(false);
        setOtpError(data.message || "OTP has expired.");
        //  setOtpMessage(data?.message || "OTP has expired.");
        setOtpDigits(Array(6).fill(""));
        setOtpSent(false);
        setResendIn(0);
      } 
      else if (res.status === 401 && data?.status === "UserAlreadyExists") {
        setOtpVerified(false);
        setOtpError(data.message || "Email Already Exists.");
        //  setOtpMessage(data?.message || "OTP has expired.");
        setOtpDigits(Array(6).fill(""));
        setOtpSent(false);
        setResendIn(0);
      } else if (res.status === 401 && data?.status === "Invalid") {
        setOtpVerified(false);
        setOtpError(data.message || "Invalid OTP.");
        // setOtpMessage(data?.message || "Invalid OTP.");
      }
       else {
        setOtpVerified(false);
        setOtpMessage(data?.message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      setOtpVerified(false);
      setOtpMessage("Network error. Please try again.");
    } finally {
      setOtpVerifyLoading(false);
    }
  };
 const [selectedDate, setSelectedDate] = useState(null);
// const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(null);

  // const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(
  //   dayjs("")
  // );

  const companyTypeRef = useRef<any>(null);
  const domainRef = useRef<any>(null);
  const interestAreaRef = useRef<any>(null);


const handleform = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  setLoading(true);
  setError(null);

  const form = e.currentTarget;

  try {

    const typedCompanyName =
      form.querySelector<HTMLInputElement>('input[placeholder="Company Name"]')?.value.trim() || "";

    const selectedCompanyValue = companyTypeRef?.current?.getValue?.()[0]?.value || "";
    const selectedCompanyLabel = companyTypeRef?.current?.getValue?.()[0]?.label || "";

    const selectedDomain = domainRef?.current?.getValue?.()[0]?.label || "";

    const selectedExpertise = interestAreaRef?.current?.getValue?.()
      ?.map((opt: any) => opt.label)
      .join(", ") || "";

    const formattedDOB = selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : "";

 
    if (!firstName || !lastName || !email || !mobile || !otpVerified) {
        toast.error("Please fill all Personal Information.");
    //  setError("Please complete all required fields from Step 1.");
      setLoading(false);
      return;
    }

    // Validation for Step 2
if (
  !selectedCompanyValue ||
  (selectedCompanyValue === "Motherson" && !selectedDomain) ||
  (selectedCompanyValue === "External" && !typedCompanyName) ||
  !selectedExpertise
) {
  toast.error("Please fill all Organizational Information.");
  setLoading(false);
  return;
}


    // Validation for Step 2
    // if (!selectedCompanyValue || (selectedCompanyValue === "Motherson" && !selectedDomain) || !selectedExpertise) {
    //     toast.error("Please fill all Organizational Information.");
    //  // setError("Please complete all required fields from Step 2.");
    //   setLoading(false);
    //   return;
    // }

    // Final payload
    const payload = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Phone: mobile,
      DOB: formattedDOB,
      Organization_Type: selectedCompanyLabel,
      Company_Name: selectedCompanyValue === "External" ? typedCompanyName : selectedDomain,
      Domain_Type: selectedDomain,
      Expertise: selectedExpertise,
    };

    // Send request
    const response = await fetch("/api/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (response.ok) {
      toast.success("Your signup request has been successfully sent for approval.");
      navigate("/signin");
    } else {
      toast.error("Signup failed. Please try again.");
    }
  } catch (err) {
    console.error("Error during signup:", err);
    toast.error("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};



  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault?.();
    setLoading(true);
    setError(null);

    const form = e.currentTarget as HTMLFormElement;

    try {
      // Collect values from Page 2
      const companyName =
        form.querySelector<HTMLInputElement>('input[placeholder="Company Name"]')
          ?.value.trim() || "";
      const otherDomain =
        form.querySelector<HTMLInputElement>('input[placeholder="Other Domain"]')
          ?.value.trim() || "";

      const formattedDOB = selectedDate
        ? dayjs(selectedDate).format("YYYY-MM-DD")
        : "";

      // const selectedCompany =
      //   companyTypeRef?.current?.getValue?.()[0]?.label || "";
      const selectedCompany = companyTypeRef?.current?.getValue?.()[0]?.label || "";
      const selectedDomain = domainRef?.current?.getValue?.()[0]?.label || "";

      // const selectedDomain = domainRef?.current?.getValue?.()[0]?.label || "";
      const selectedExpertise =
        interestAreaRef?.current?.getValue
          ?.map((opt: any) => opt.label)
          .join(", ") || "";

      // Final form validation (only for Step 2)
      if (!selectedCompany || !selectedDomain || !selectedExpertise) {
        setError("Please complete all required fields on this page.");
        setLoading(false);
        return;
      }


      const payload = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Phone: mobile,
        DOB: formattedDOB,
        Organization_Type: selectedCompany,

        Company_Name: companyName,
        Domain_Type: selectedDomain,
        Domain: otherDomain,
        Expertise: selectedExpertise,
      };

      const response = await fetch("/api/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {

        alert("success");
        toast.success("Your signup request has been successfully sent for approval.");
        setTimeout(() => {
          navigate("/signin");
        }, 1000);

        // navigate("/signin");
      } else {

        setError(data.message || "Signup failed. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  //   e.preventDefault();
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const form = e.currentTarget as HTMLFormElement;

  //     const firstName =
  //       form.querySelector<HTMLInputElement>('input[placeholder="First Name"]')
  //         ?.value || "";
  //     const lastName =
  //       form.querySelector<HTMLInputElement>('input[placeholder="Last Name"]')
  //         ?.value || "";
  //     const phone =
  //       form.querySelector<HTMLInputElement>('input[placeholder="Mobile No."]')
  //         ?.value || "";
  //     const email =
  //       form.querySelector<HTMLInputElement>('input[placeholder="Email Id"]')
  //         ?.value || "";
  //     const companyName =
  //       form.querySelector<HTMLInputElement>(
  //         'input[placeholder="Company Name"]'
  //       )?.value || "";
  //     const otherDomain =
  //       form.querySelector<HTMLInputElement>(
  //         'input[placeholder="Other Domain"]'
  //       )?.value || "";

  //     const formattedDOB = selectedDate
  //       ? dayjs(selectedDate).format("YYYY-MM-DD")
  //       : "";

  //     const selectedCompany =
  //       companyTypeRef?.current?.getValue?.()[0]?.label || "";
  //     const selectedDomain = domainRef?.current?.getValue?.()[0]?.label || "";
  //     const selectedExpertise =
  //       interestAreaRef?.current?.getValue
  //         ?.map((opt: any) => opt.label)
  //         .join(", ") || "";

  //     const payload = {
  //       FirstName: firstName,
  //       LastName: lastName,
  //       Email: email,
  //       Phone: phone,
  //       DOB: formattedDOB,
  //       Organization_Type: selectedCompany,
  //       Company_Name: companyName,
  //       Domain_Type: selectedDomain,
  //       Domain: otherDomain,
  //       Expertise: selectedExpertise,
  //     };

  //     const response = await fetch("/api/signup", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       navigate("/signin");
  //     } else {
  //       setError(data.message || "Signup failed. Please try again.");
  //     }
  //   } catch (err) {
  //     console.error("Signup error:", err);
  //     setError("Something went wrong. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //   if (parts.length !== 2) {
  //     setError("Please enter username in Domain\\Username format");
  //     setTimeout(() => setError(null), 5000);
  //     return;
  //   }

  //   const [domain, username] = parts;

  //   try {
  //     const response = await fetch(
  //       "/Check_User_Eligibility",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           WindowID: username,
  //           Domain: domain,
  //         }),
  //       }
  //     );

  //     const data = await response.json();

  //     if (response.ok && data.message !== "User does not exist") {
  //       localStorage.setItem("userId", username);
  //       localStorage.setItem("domain", domain);

  //       localStorage.setItem("sessionStart", Date.now().toString());

  //       navigate("/");
  //     } else {
  //       setError("You are not an authorized user.");
  //       setTimeout(() => setError(null), 5000);
  //     }
  //   } catch (err) {
  //     console.error("Login error:", err);
  //     setError("Something went wrong. Please try again.");
  //     setTimeout(() => setError(null), 5000);
  //   }
  //   setLoading(false);
  // };


 const isStepValid = React.useMemo(() => {
  return (
    firstName.trim() !== "" &&
    lastName.trim() !== "" &&
    selectedDate !== null &&
    email.trim() !== "" &&
    otpVerified === true &&
    mobile.trim().length === 10
  );
}, [firstName, lastName, selectedDate, email, otpVerified, mobile]);


// }, [mobile]);


  //  useEffect(() => {
  //   if (isStepValid) {
  //     handleNext(); 
  //   }
  // }, [isStepValid]);

  // stepper start
  const [interestArea, setInterestArea] = useState<{ value: string; label: string }[]>([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setSelectedDomain(null);
    setCompanyName("");
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };


   const fetchExpertise = async () => {
      try {
        const response = await fetch(`${BackendURL}/Category_Dropdown_list`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
       
        if (!response.ok) {
          throw new Error("Failed to fetch icons.");
        }
        const data = await response.json();
         
        return data;
      } catch (error) {
        return [];
      }
    };

  
    useEffect(() => {
      const getData = async () => {
        const optionsData = await fetchExpertise();
  
        const formattedOptions = optionsData.map((item: any) => ({
          value: item.SubCategory,
          label: item.SubCategory,
        }));
      setInterestArea(formattedOptions);
       
      };
  
      getData();
    }, []);

  // stepper end

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className={styles.signUpPage}>

        <div className={styles.signUpPagePanelWrapper}>
          <div className={styles.signUpPageTopPanel}>
            <div className={styles.signUpContentWrapper}>
              <div className={styles.signUpContentWrapper_inner}>

                <h1>
                  Welcome to <span>Lipi!</span>
                </h1>
                <p>
                  Lipi is a versatile chatbot platform that combines multiple AI
                  models to deliver personalized and efficient interactions. It
                  adapts to various needs—from casual chats to complex
                  problem-solving-offering accurate, context-aware responses.
                  Ideal for customer service, finance, retail, automotive and
                  manufacturing, Lipi continuously improves to power smarter
                  conversations.
                </p>
              </div>
            </div>
            <div className={styles.loginForm}>
              <div className={styles.forWrp}>
                <div className={styles.forWrp__inner}>
                  {/* <div className={styles.forWrp__inner__logo}>
              <i><svg width="100%" height="100%" viewBox="0 0 109 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M103.473 8.02431C102.315 8.02431 101.32 7.64944 100.487 6.8997C99.6747 6.14994 99.2686 5.19758 99.2686 4.04256C99.2686 2.88754 99.6747 1.92503 100.487 1.15502C101.32 0.385005 102.315 0 103.473 0C104.671 0 105.686 0.385005 106.519 1.15502C107.352 1.92503 107.768 2.88754 107.768 4.04256C107.768 5.13677 107.352 6.07903 106.519 6.86931C105.686 7.63931 104.671 8.02431 103.473 8.02431ZM106.976 42.1581C106.976 44.1053 105.394 45.6838 103.442 45.6838C101.49 45.6838 99.9083 44.1053 99.9083 42.1581V18.0851C99.9083 16.1378 101.49 14.5593 103.442 14.5593C105.394 14.5593 106.976 16.1378 106.976 18.0851V42.1581Z" fill="white"></path><path d="M70.0538 40.0772C70.0388 40.053 70.0121 40.0378 69.9835 40.0378C69.9382 40.0378 69.9014 40.0746 69.9014 40.1199V56.2914C69.9014 58.3397 68.2371 60 66.1843 60C64.1314 60 62.467 58.3395 62.467 56.2914V15.7289C62.467 13.6806 64.1314 12.0202 66.1843 12.0202H67.0063C68.6052 12.0202 69.9014 13.3134 69.9014 14.9087V17.7159C69.9014 17.7607 69.9379 17.7971 69.9828 17.7971C70.0117 17.7971 70.0386 17.7814 70.0533 17.7564C72.5948 13.4188 76.304 11.25 81.181 11.25C85.3467 11.25 88.594 12.7156 90.9224 15.6468C93.2511 18.578 94.4153 22.5148 94.4153 27.4571C94.4153 32.9346 93.1015 37.3206 90.4738 40.6155C87.8462 43.9104 84.2573 45.558 79.7069 45.558C75.5348 45.558 72.3171 43.731 70.0538 40.0772ZM69.8373 27.072V31.1479C69.8373 33.5443 70.5956 35.5768 72.1124 37.2458C73.6506 38.9145 75.5946 39.7491 77.9445 39.7491C80.7003 39.7491 82.8579 38.6792 84.4176 36.5396C85.9983 34.3787 86.7887 31.3727 86.7887 27.5214C86.7887 24.2906 86.0518 21.7659 84.5777 19.9474C83.125 18.1073 81.1489 17.1873 78.6496 17.1873C76.0005 17.1873 73.8641 18.1287 72.2406 20.0115C70.6385 21.8944 69.8373 24.2479 69.8373 27.072Z" fill="white"></path><path d="M48.7936 43.1359C48.7911 43.0226 48.7434 42.9148 48.6599 42.8348C48.5765 42.7547 48.4639 42.7088 48.3459 42.7065L34.9975 42.7078C34.987 42.7078 34.9782 42.7022 34.9677 42.7022C34.9058 42.6986 34.8448 42.6881 34.7856 42.6707C34.7457 42.6634 34.7066 42.6533 34.6685 42.6399C34.613 42.6129 34.5612 42.5796 34.514 42.5404C34.4826 42.5205 34.4527 42.4986 34.4245 42.4746C34.3832 42.4283 34.3473 42.3776 34.3178 42.3236C34.2979 42.2942 34.2798 42.2636 34.2642 42.2319C34.259 42.2198 34.2447 42.2134 34.2432 42.1976L30.2474 30.8378C30.0444 30.1551 30.014 29.4356 30.1587 28.7394C30.3034 28.0431 30.6189 27.39 31.0792 26.8339L40.0409 16.0194C40.3062 15.6958 40.6462 15.4354 41.0339 15.2586C41.4216 15.0818 41.8467 14.9935 42.2761 15.0004L42.2804 15.0047L42.2849 15.0004L42.3007 15.004C42.6742 14.9995 43.0449 15.0668 43.3909 15.202C43.7369 15.3372 44.0511 15.5375 44.315 15.7911C44.392 15.8651 44.4646 15.9432 44.532 16.0252L53.4922 26.8369C53.9551 27.3983 54.271 28.0579 54.4136 28.7604C54.5563 29.463 54.5215 30.1881 54.3122 30.8751L52.4283 36.2316C52.3956 36.3266 52.3438 36.4146 52.2754 36.4903C52.2071 36.5661 52.1239 36.6281 52.0307 36.6728C51.9373 36.7176 51.8356 36.7442 51.7315 36.7511C51.6274 36.7581 51.5229 36.7451 51.4238 36.7131C51.325 36.681 51.2337 36.6306 51.1551 36.5646C51.0767 36.4986 51.0127 36.4183 50.9666 36.3285C50.9206 36.2387 50.8935 36.141 50.8871 36.0411C50.8805 35.9411 50.8948 35.841 50.9288 35.7463L52.8014 30.4236C52.9352 29.973 52.9553 29.4986 52.8598 29.0393C52.7645 28.5799 52.5565 28.149 52.253 27.7821L43.3018 16.9648C43.2372 16.8891 43.1633 16.8211 43.0818 16.7622V26.4604C44.0701 26.6486 44.9502 27.183 45.5506 27.9593C46.1511 28.7355 46.429 29.6983 46.3304 30.6602C46.2317 31.6221 45.7636 32.5146 45.0169 33.1637C44.2703 33.8128 43.2986 34.1724 42.291 34.1724C41.2833 34.1724 40.3117 33.8128 39.565 33.1637C38.8184 32.5146 38.3502 31.6221 38.2516 30.6602C38.1529 29.6983 38.4309 28.7355 39.0313 27.9593C39.6317 27.183 40.5118 26.6486 41.5002 26.4604L41.4994 16.7601C41.4182 16.82 41.3455 16.8898 41.2831 16.9676L32.3199 27.7764C32.019 28.1385 31.8116 28.5636 31.7148 29.0171C31.618 29.4707 31.6343 29.94 31.7627 30.3863L35.5675 41.1923L48.3489 41.1879C48.6154 41.1878 48.8793 41.2378 49.1255 41.3355C49.3716 41.4332 49.5955 41.5766 49.7838 41.7574C49.9723 41.9381 50.1217 42.1526 50.2235 42.3889C50.3254 42.6249 50.3776 42.8781 50.3774 43.1336L50.3782 46.7998C50.378 47.316 50.1641 47.811 49.7836 48.1761C49.403 48.5409 48.8872 48.7461 48.3489 48.7462L31.6699 48.7498C31.5648 48.7517 31.4605 48.7333 31.3628 48.696C31.2652 48.6587 31.1763 48.6032 31.1014 48.5325C31.0264 48.462 30.9668 48.3778 30.9262 48.2848C30.8854 48.1918 30.8644 48.0921 30.8644 47.9914C30.8644 47.8905 30.8852 47.7908 30.9258 47.6978C30.9664 47.6048 31.0258 47.5206 31.1008 47.4499C31.1758 47.3792 31.2645 47.3235 31.362 47.2862C31.4597 47.2487 31.564 47.2303 31.6691 47.232L48.3482 47.2313C48.407 47.2316 48.4654 47.2207 48.5199 47.1992C48.5743 47.1778 48.6239 47.1461 48.6654 47.1062C48.7071 47.0663 48.74 47.0188 48.7624 46.9667C48.7847 46.9144 48.7962 46.8585 48.7958 46.8019L48.7936 43.1359ZM40.546 31.9414C40.8911 32.2723 41.3308 32.4979 41.8095 32.5892C42.2881 32.6805 42.7845 32.6336 43.2353 32.4544C43.6864 32.2753 44.0718 31.9719 44.3428 31.5827C44.614 31.1933 44.7589 30.7358 44.7589 30.2676C44.7589 29.7994 44.614 29.3417 44.3428 28.9524C44.0718 28.563 43.6864 28.2596 43.2353 28.0806C42.7845 27.9013 42.2881 27.8544 41.8095 27.9458C41.3308 28.0371 40.8911 28.2626 40.546 28.5936C40.0837 29.0378 39.824 29.6398 39.824 30.2676C39.824 30.8951 40.0837 31.4972 40.546 31.9414Z" fill="white" stroke="white" stroke-width="0.9"></path><path d="M43.6885 8.42644C46.0207 8.42644 47.9114 6.54012 47.9114 4.21322C47.9114 1.88632 46.0207 0 43.6885 0C41.3562 0 39.4656 1.88632 39.4656 4.21322C39.4656 6.54012 41.3562 8.42644 43.6885 8.42644Z" fill="white"></path><path d="M26.3103 47.3462C26.3103 49.1571 24.839 50.625 23.024 50.625H3.75862C1.68279 50.625 0 48.9461 0 46.875V3.75C0 1.67893 1.68279 0 3.75862 0H4.12785C6.20368 0 7.88647 1.67893 7.88647 3.75V40.3174C7.88647 42.3883 9.56926 44.0674 11.6451 44.0674H23.024C24.839 44.0674 26.3103 45.5353 26.3103 47.3462Z" fill="white"></path></svg></i>
            </div> */}

                  <div className={styles.loginElementWrapper}>
                    <h2 style={{ marginBottom: "1.5rem" }}>Register!</h2>
                    {/* <p>Access to the most powerfull tool in the industry.</p> */}

                    <Box sx={{ width: "100%" }} className="registeration_steps">
                      <Stepper
                        className="stepperInlineUi"
                        activeStep={activeStep}
                      >
                        {steps.map((label, index) => {
                          const stepProps: { completed?: boolean } = {};
                          const labelProps: {
                            optional?: React.ReactNode;
                          } = {};
                          if (isStepOptional(index)) {
                            labelProps.optional = (
                              <Typography variant="caption"></Typography>
                            );
                          }
                          if (isStepSkipped(index)) {
                            stepProps.completed = false;
                          }
                          return (
                            <Step key={label} {...stepProps}>
                              <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                          );
                        })}
                      </Stepper>

                      {activeStep === steps.length ? (
                        <React.Fragment>
                          <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              pt: 2,
                            }}
                          >
                            <Box sx={{ flex: "1 1 auto" }} />
                            <Button onClick={handleReset}>Reset</Button>
                          </Box>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography sx={{ mt: 2, mb: 1 }}>
                            {/* Step {activeStep + 1} */}
                            {activeStep === 0 && (
                              <form
                                style={{ marginTop: "1rem" }}
                                //   onSubmit={handleSubmit}
                                className={styles.forWrp__signInform}
                              >
                                {/* Step 1 Form: Personal Info */}
                                <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                    <input
                                      className={styles.formControl}
                                      type="text"
                                      placeholder="First Name"
                                      value={firstName}
                                      onChange={(e) => setFirstName(e.target.value)}
                                    />
                                  </div>
                                  <div className={styles.formGroup}>
                                    <input
                                      className={styles.formControl}
                                      type="text"
                                      placeholder="Last Name"
                                      value={lastName}
                                      onChange={(e) => setLastName(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                     <DatePicker
                                        placeholder="Date of Birth"          
                                        format="DD-MM-YYYY"        
                                        value={selectedDate}        
                                      //  onChange={setSelectedDate}  
                                         className={styles.dateOfBirthWrapper}
                                          inputReadOnly
                                        onChange={(newValue) =>
                                          setSelectedDate(newValue)
                                          
                                        }   
                                      />
                                  
                                  </div>
                                  <div className={styles.formGroup}>
                                    <input
                                      className={styles.formControl}
                                      type="text"
                                      placeholder="Mobile No."
                                      value={mobile}
                                      maxLength={10}
                                      onChange={(e) => {
                                        const val = e.target.value;

                                        if (/^\d{0,10}$/.test(val)) {
                                          setMobile(val);
                                        }
                                      }}
                                    />
                                  </div>

                                </div>

                                <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                    <div
                                      className={
                                        styles.verificationInputContainer
                                      }
                                    >
                                      <input
                                        className={styles.formControl}
                                        type="text"
                                        placeholder="Email Id"
                                        value={email}
                                        onChange={(e) => {
                                          setEmail(e.target.value);
                                          setEmailError(null);
                                          setOtpDigits(Array(6).fill(""));
                                          setOtp(""); 
                                          setOtpSent(false);
                                          setOtpVerified(false);
                                          setOtpMessage(null);
                                          setIsEmailChanged(true);
                                        }}
                                        disabled={
                                          otpVerified ||
                                          otpLoading ||
                                          otpVerifyLoading
                                        }
                                      />

   {!otpVerified ? (
  <a
    className={`${styles.verifyMe} ${
      otpLoading || otpVerifyLoading || !isEmailChanged  ? styles.disabledLink : ""
    }`}
    href="#"
    role="button"
    aria-disabled={
      otpLoading || otpVerifyLoading || resendIn > 0
    }
  
    onClick={(e) => {
      e.preventDefault();
      if (
        !otpLoading &&
        !otpVerifyLoading &&
        resendIn === 0
      ) {
        handleSendOtp();
            setIsEmailChanged(false); 
      }
    }}

  >
    {otpLoading ? "Sending..." : "Verify me"}
  </a>
) : (
  <span className={styles.veifyMeicon} aria-label="Verified">
    <i>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="100%"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign: "middle" }}
      >
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
      </svg>
    </i>
  </span>
)}

                                        {/* <a
                                          className={`${styles.verifyMe} ${otpLoading ||
                                              otpVerifyLoading ||
                                              resendIn > 0 ||
                                              otpVerified
                                              ? styles.disabledLink
                                              : ""
                                            }`}
                                          href="#"
                                          role="button"
                                          aria-disabled={
                                            otpLoading ||
                                            otpVerifyLoading ||
                                            resendIn > 0 ||
                                            otpVerified
                                          }
                                          onClick={handleSendOtp}
                                        >
                                  {otpLoading ? "Sending..." : "Verify me"}
                                    </a>
                            {otpVerified && (
                                  <span className={styles.veifyMeicon}> <i>
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth="0"
                                            viewBox="0 0 512 512"
                                            height="100%"
                                            width="100%"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ verticalAlign: "middle" }}
                                          >
                                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                                          </svg></i>
                                          </span>
  )} */}

                                        {/* {otpLoading ? (
                                          "Sending..."
                                        ) : otpVerified ? (
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ verticalAlign: "middle" }}
                                          >
                                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                                          </svg>
                                        ) : (
                                          "Verify me"
                                        )} */}

                                        {/* {otpLoading
                                          ? "Sending..."
                                          : otpVerified
                                            ? "Verified"
                                            : "Verify me"} */}
                                      {/* </a> */}
                                    </div>

                                    {emailError && (
                                      <div className={styles.signUpErrorText}>
                                        {emailError}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                    <div
                                      className={
                                        styles.verificationInputContainer_otpwrapper
                                      }
                                    >
                                      <div className={styles.otpSection}>
                                        <div
                                          className={
                                            styles.verificationInputContainer__otp
                                          }
                                        >
                                          {otpDigits.map((digit, index) => (
                                            <input
                                              key={index}
                                              id={`otp-input-${index}`}
                                              type="text"
                                              maxLength={1}
                                              className={styles.formControl}
                                              placeholder="-"
                                              value={digit}
                                              onChange={(e) =>
                                                handleOtpChange(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                              disabled={
                                                !otpSent ||
                                                otpVerified ||
                                                otpLoading ||
                                                otpVerifyLoading
                                              }
                                            />
                                          ))}
                                        </div>

                                        <div className={styles.otpGet}>
                                          {!otpVerified&&(
                                           <a
    className={`${styles.verifyOtp} ${
      !otpSent || otpVerifyLoading || otpVerified || !isOtpComplete()
        ? styles.disabledLink
        : ""
    }`}
    href="#"
    role="button"
    aria-disabled={
      !otpSent || otpVerifyLoading || otpVerified || !isOtpComplete()
    }
    onClick={(e) => {
      e.preventDefault();
      if (
        !otpSent ||
        otpVerifyLoading ||
        otpVerified ||
        !isOtpComplete()
      )
        return;
      handleVerifyOtp(e);
    }}
  >
    
 {otpVerifyLoading  ? "Verifying..." : "Verify OTP"}
   
   
  </a>
  )}

 
 {otpVerified && (
  <div>
    <i
      style={{
        display: "flex",
        width: "20px",
        height: "20px",
        color: "green",
        textAlign: "center",
        background: "#fff",
        borderRadius: "20px",
        border: "1px solid #fff",
        justifyContent: "center",
        alignItems: "center",
      }}
      aria-label="OTP Verified"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="100%"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign: "middle" }}
      >
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
      </svg>
    </i>
  </div>
)}

                                          {/* <a
                                            className={`${styles.verifyOtp} ${!otpSent ||
                                                otpVerifyLoading ||

                                                otpVerified || !isOtpComplete()
                                                ? styles.disabledLink
                                                : ""
                                              }`}
                                            href="#"
                                            role="button"
                                            aria-disabled={
                                              !otpSent ||
                                              otpVerifyLoading ||
                                              otpVerified ||
                                              !isOtpComplete()

                                            }
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (
                                                !otpSent ||
                                                otpVerifyLoading ||
                                                otpVerified ||
                                                !isOtpComplete()
                                              )
                                                return;
                                              handleVerifyOtp(e);
                                            }}
                                          >
                                           
                                                {otpVerifyLoading ? (
                                                      "Verifying..."
                                                    ) : otpVerified ? (
                                                     
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="currentColor"
                                                        strokeWidth="0"
                                                        viewBox="0 0 512 512"
                                                        height="1em"
                                                        width="1em"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        style={{ verticalAlign: "middle" }}
                                                      >
                                                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                                                      </svg>
                                                    ) : (
                                                      "Verify OTP"
                                                    )}

                                          </a> */}

                                          <span>
                                            {otpSent && !otpVerified && (
                                              resendIn > 0 ? (
                                                <span className={styles.resendDisabled}>
                                                  Resend in {resendIn}s
                                                </span>
                                              ) : (
                                                <a
                                                  className={styles.verifyOtp}
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSendOtp(e);
                                                  }}
                                                >
                                                  Resend Code
                                                </a>
                                              )
                                            )}
                                          </span>

                                          {/* <span>
                                             Didn't get it?{" "} 
                                            {resendIn > 0 ? (
                                              <span
                                                className={
                                                  styles.resendDisabled
                                                }
                                              >
                                                Resend in {resendIn}s
                                              </span>
                                            ) : (
                                              <a
                                                className={styles.verifyOtp}
                                                href="#"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  handleSendOtp(e); 
                                                }}
                                              >
                                                Resend Code
                                              </a>
                                            )}
                                          </span> */}

                                          {/* {resendIn > 0 && (
                                            <div className="otpTimer">
                                              <CircularProgressWithLabel
                                                value={
                                                  ((RESEND_SECONDS - resendIn) /
                                                    RESEND_SECONDS) *
                                                  100
                                                }
                                              />
                                            </div>
                                          )} */}
                                        </div>
                                      </div>


                                      {/* <div className="otpTimer">
                                        {resendIn > 0 && (
                                          <CircularProgressWithLabel
                                            value={progress}
                                          />
                                        )}
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </form>
                            )}
                            
                            {otpError && <p className={styles.signUpErrorText_email}>{otpError}</p>}
                            {/* <Button onClick={handleNext} disabled={!isStepValid || loading}> */}
                            {activeStep === 0 && (
                              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
                                <Button
                                  onClick={handleNext}
                                  disabled={!isStepValid}
                                  style={{
                                    backgroundColor: isStepValid ? "#db2128" : "#ccc",
                                    color: isStepValid ? "white" : "#666",
                                    padding: "0.5rem 1.5rem",
                                    borderRadius: "40px",
                                    height:"40px",
                                    border: "none",
                                    cursor: isStepValid ? "pointer" : "not-allowed",
                                    opacity: isStepValid ? 1 : 0.6,
                                  }}
                                >
                                  Next
                                </Button>

                              </div>
                            )}
                            {activeStep === 1 && (

                              <form
                                onSubmit={handleform}
                                style={{ marginTop: "1rem" }}
                                className={styles.forWrp__signInform}
                              >
                                {/* <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                    <Select
                                      ref={companyTypeRef}
                                      className="signupselect"
                                      closeMenuOnSelect={true}
                                      components={animatedComponents}
                                      options={companyType}
                                      placeholder="Select Company Type"
                                      onChange={(selectedOption) => {
                                      setSelectedCompany((selectedOption as any)?.value || "");
                                      setSelectedDomain(null);   
                                       setCompanyName('');         
      }}
                                      
                                    />
                                  </div>
                                  {selectedCompany === "MOTHERSOON" && (
                                    <div className={styles.formGroup}>
                                    <Select
                                      ref={domainRef}
                                      className="signupselect"
                                      closeMenuOnSelect={true}
                                      components={animatedComponents}
                                      options={domain}
                                      placeholder="Select Domain"
                                      menuPortalTarget={document.body}
                                      onChange={(selectedOption) => setSelectedDomain(selectedOption as DomainOption)}
                                    />
                                  </div>
                                  )}
                                </div> */}

<div className={styles.formGroupRow}>
  <div className={styles.formGroup}>
    <Select
      ref={companyTypeRef}
      className="signupselect"
      closeMenuOnSelect={true}
      components={animatedComponents}
      options={companyType}
      placeholder="Select Company Type"
      onChange={(selectedOption) => {
        setSelectedCompany((selectedOption as any)?.value || "");
        setSelectedDomain(null);
        setCompanyName("");
      }}
    />
  </div>

  {selectedCompany !== "External" && (
    <div className={styles.formGroup}>
      <Select
        ref={domainRef}
        className="signupselect"
        closeMenuOnSelect={true}
        components={animatedComponents}
        options={domain}
        placeholder="Select Domain"
        menuPortalTarget={document.body}
        onChange={(selectedOption) => setSelectedDomain(selectedOption as DomainOption)}
        value={selectedDomain}
      />
    </div>
  )}

  {selectedCompany === "External" && (
    <div className={styles.formGroup}>
      <input
        className={styles.formControl}
        type="text"
        placeholder="Company Name"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
      />
    </div>
  )}
</div>

                                {/* <div className={styles.formGroupRow}>
                                  {selectedCompany === "EXTERNAL" && (
                                  <div className={styles.formGroup}>
                                    <input
                                      className={styles.formControl}
                                      type="text"
                                      placeholder="Company Name"
                                    />
                                  </div>
                                  )} */}
                                  {/* <div className={styles.formGroup}>
                                    <input
                                      className={styles.formControl}
                                      type="text"
                                      placeholder="Other Domain"
                                      disabled={selectedDomain?.value !== 'other'}
                                      
                                    />
                                  </div> */}
                                {/* </div> */}
                                <div className={styles.formGroupRow}>
                                  <div className={styles.formGroup}>
                                    {/* <label>Password</label> */}
                                    {/* <select className={styles.formControl} name="domain" id="domain" aria-label="domain"> 
                       <option value="Select">Select Interest Area</option>                     
                      <option value="General">General</option>
                      <option value="Retail">Retail</option>
                      <option value="Manufacturing">Manufacturing</option>
                      <option value="Automotive">Automotive</option> 
                      <option value="Pharma">Pharma</option>                     
                    </select> */}
                                    <div className={styles.interstCategory}>
                                      <Select
                                        ref={interestAreaRef}
                                        className="signupselect"
                                        closeMenuOnSelect={true}
                                        components={animatedComponents}
                                      //  isMulti
                                        options={interestArea}
                                        placeholder="Select Interest Area"
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuList: (provided) => ({
                                            ...provided,
                                            maxHeight: "120px",
                                            overflowY: "auto",
                                          }),
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {activeStep === 1 && (
                                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
                                    <Button
                                      style={{
                                        backgroundColor: "#db2128",
                                        color: "white",
                                        padding: "0.5rem 1.5rem",
                                         borderRadius: "40px",
                                         height:"40px",
                                        border: "none",
                                        cursor: loading ? "not-allowed" : "pointer",
                                        opacity: loading ? 0.7 : 1,
                                      }}
                                      onClick={handleBack}
                                      sx={{ mr: 1 }}
                                    >
                                      Back
                                    </Button>

                                    <Button
                                      type="submit"
                                      disabled={loading}
                                      style={{
                                        backgroundColor: "#db2128",
                                        color: "white",
                                        padding: "0.5rem 1.5rem",
                                         borderRadius: "40px",
                                    height:"40px",
                                        border: "none",
                                        cursor: loading ? "not-allowed" : "pointer",
                                        opacity: loading ? 0.7 : 1,
                                      }}
                                    >
                                      {loading ? "Submitting..." : "Submit"}
                                    </Button>
                                  </div>
                                )}

                              </form>

                            )}
                          </Typography>
                          <Box
                            className="stepsButton"
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              pt: 2,
                            }}
                          >

                            <Box sx={{ flex: "1 1 auto" }} />
                            {isStepOptional(activeStep) && (
                              <Button
                                style={{ display: "none" }}
                                color="inherit"
                                onClick={handleSkip}
                                sx={{ mr: 1 }}
                              >
                                Skip
                              </Button>
                            )}

                            {/* <Button
  onClick={activeStep === steps.length - 1 ? handleSubmit : handleNext}
  disabled={loading}
>
  {activeStep === steps.length - 1 ? (loading ? "Submitting..." : "Finish") : "Next"}
</Button> */}
                            {/* <Button onClick={handleNext}>
                              {activeStep === steps.length - 1
                                ? "Finish"
                                : "Next"}
                            </Button> */}
                          </Box>
                        </React.Fragment>
                      )}
                    </Box>
                      <p className={styles.signInUpTextWrapper}>Already have an account?  <Link className={styles.signInUpText} to="/signin">
                      Sign In
                    </Link></p>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.poweredByWrapper}>
            <span className={styles.poweredByonLogin}>
              Powered by
              <svg
                height="28"
                viewBox="0 0 89 20"
                width="92"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Samvardhana Motherson</title>
                <path
                  d="M85.535 1.38a2.464 2.464 0 0 0-1.478 2.231v16.107h3.45c.817 0 1.479-.662 1.479-1.479V0zm-6.408 4.93a2.466 2.466 0 0 0-1.479 2.23v11.178h3.45a1.48 1.48 0 0 0 1.48-1.479V4.93zm-6.409 4.93a2.465 2.465 0 0 0-1.478 2.23v6.248h3.45c.817 0 1.479-.662 1.479-1.479V9.86zM.784 12.97h2.27v1.014c.356-.634 1.054-1.192 2.082-1.192.875 0 1.484.38 1.801 1.103.571-.774 1.358-1.103 2.195-1.103 1.256 0 2.17.811 2.17 2.475v4.338H9.031v-3.959c0-.671-.33-1.001-.85-1.001-.61 0-1.015.393-1.015 1.116v3.844H4.92v-3.959c0-.671-.33-1.001-.85-1.001-.609 0-1.015.393-1.015 1.116v3.844H.784zm16.241 3.362v-.101c0-1.117-.443-1.739-1.306-1.739-.85 0-1.32.597-1.32 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.948.039v-.101c0-2.132 1.587-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452-2.042 0-3.629-1.243-3.629-3.388m8.26 1.104v-2.956h-.799V12.97h.8v-.467l2.271-.916v1.383h1.307v1.548h-1.307v2.74c0 .483.24.699.672.699.254 0 .444-.038.647-.114v1.724a4.73 4.73 0 0 1-1.256.19c-1.497 0-2.335-.723-2.335-2.283m4.51-6.757l2.27-.926v4.244c.356-.685 1.08-1.243 2.184-1.243 1.28 0 2.17.799 2.17 2.5v4.313h-2.272v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27zm12.143 4.816c-.039-.8-.432-1.244-1.168-1.244-.685 0-1.154.444-1.269 1.244zm-4.759.837v-.101c0-2.132 1.586-3.477 3.59-3.477 1.815 0 3.377 1.04 3.377 3.426v.596h-4.67c.064.875.571 1.384 1.383 1.384.749 0 1.066-.343 1.155-.788h2.132c-.204 1.498-1.359 2.348-3.363 2.348-2.081 0-3.604-1.218-3.604-3.388zm7.833-3.4h2.271v1.319c.419-.99 1.116-1.422 2.144-1.407V15c-1.383-.038-2.144.393-2.144 1.458v3.147h-2.271zm4.772 4.53h2.093c.077.482.292.748.94.748.558 0 .811-.216.811-.545 0-.318-.317-.47-1.23-.597-1.776-.228-2.526-.749-2.526-2.131 0-1.473 1.308-2.183 2.843-2.183 1.637 0 2.778.558 2.931 2.145h-2.056c-.089-.445-.33-.66-.85-.66-.495 0-.749.215-.749.52 0 .317.305.444 1.117.545 1.84.229 2.728.71 2.728 2.132 0 1.573-1.167 2.284-3.007 2.284-1.89 0-2.995-.788-3.045-2.259m11.413-1.167v-.101c0-1.117-.444-1.739-1.307-1.739-.85 0-1.319.597-1.319 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.949.039v-.101c0-2.132 1.586-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452S51.3 18.515 51.3 16.37m8.066-3.4h2.272v1.065c.355-.685 1.078-1.243 2.182-1.243 1.282 0 2.17.799 2.17 2.5v4.313h-2.27v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27z"
                  fill="currentColor"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </span>
          </div>
 

        </div>
      </div>
    </LocalizationProvider>
  );
}